import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { useTl, useApiService } from "../../../../../hooks";
import { PersonGridDto, PersonApi, PersonSearch } from "../../../../../api";
import { useGlobalData } from "../../../../../contexts";
import { ETLCodes } from "../../../../../locales";
import { CustomDataTable } from "../../../../../components";
import { generateAddress } from "../../../../../utils";

export interface IKennelOwnersSelectionPanelProps {
  onPersonSelected: (person: PersonGridDto) => void;
}

export const KennelOwnersSelectionPanel: React.FunctionComponent<IKennelOwnersSelectionPanelProps> = (props) => {
  const api = useApiService(PersonApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10, 15],
    pageSize: 10,
    sortKeys: { lastName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: PersonGridDto) =>
      api.baseSearch(
        PersonSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: PersonGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                props.onPersonSelected(row);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.LastName),
        fieldName: "lastName",
      },
      {
        header: () => t(ETLCodes.FirstName),
        fieldName: "firstName",
      },
      {
        header: () => t(ETLCodes.MailAddress),
        fieldName: "address",
        render: (row: PersonGridDto) => generateAddress(row.number, row.street, row.city, row.postalCode, row.country),
      },
    ],
    [props, t]
  );

  return (
    <div>
      <CustomDataTable
        columns={columns}
        filterMode="OnEnter"
        //sortKeys={{ lastName: "ASC" }}
        //withCard={false}
        tableState={tableState}
        loading={loading}
      />
    </div>
  );
};
